import React, { useEffect, useState } from "react";

import { connect } from "react-redux";

// component functions
import * as ComponentFunctions from "./ChangeTypeOfConsumption.Functions";
import { Divider, Label, Badge, MessageBar, MessageBarBody, MessageBarTitle, Subtitle2, Switch, ToggleButton, Button } from "@fluentui/react-components";
import { FontSizes, Separator } from "@fluentui/react";
import Moment from "react-moment";
import ConfirmationModalComponent from "../../../commons/component/ConfirmationModal/ConformationModal.Component";

const ChangeTypeOfConsumptionComponent = (props: ComponentFunctions.Props) => {

    const [isRemote, setIsRemote] = useState(false);
    const [isPresential, setIsPresential] = useState(true);

    const handleChange = (event: React.FormEvent<HTMLButtonElement>) => {
        if (event.currentTarget.getAttribute("aria-pressed") === "true") {
            // do nothing
        } else {
            setIsRemote(!isRemote);
            setIsPresential(!isPresential);
        }
    };

    useEffect(() => {
        if (props.Consumption?.currentConsumptionType === 1) {
            setIsRemote(true);
            setIsPresential(false);
        } else {
            setIsRemote(false);
            setIsPresential(true);
        }
    }, [props.Consumption?.currentConsumptionType]);

    return (
        <>
            <Subtitle2 style={{ fontSize: FontSizes.size14 }}>Como se realizo la prestación</Subtitle2>
            <>
                <MessageBar key={props.Consumption?.id} intent={props.Consumption?.currentConsumptionType === props.Consumption?.originalConsumptionType ? "info" : "warning"}>
                    <MessageBarBody>
                        <MessageBarTitle>
                            {props.Consumption?.serviceName}&nbsp;|&nbsp;
                            <Moment format="DD/MM/YYYY HH:mm" date={props.Consumption?.serviceDueDate} />
                            <Badge>{props.Consumption?.originalConsumptionType === 0 ? "Presencial" : "Remota"}</Badge> </MessageBarTitle>
                        {props.Consumption?.currentConsumptionType === props.Consumption?.originalConsumptionType ? "" : "Se ha modificado la modalidad de la prestación"}
                    </MessageBarBody>
                </MessageBar>
            </>
            <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                {isRemote && (
                    <>
                        <ConfirmationModalComponent
                            onDismiss={() => handleChange}
                            onConfirm={() => { props.ChangeVisitType(props.ProtocolId, props.Consumption!.id, 0) }}
                            title="Desea cambiar la modalidad de la prestación?"
                            message="Es importante tener en cuenta que al cambiar la modalidad de la prestación, NO se esta modificando la prestacion del servicio en el módulo medico o en la historia clinica. Solo se esta modificando la modalidad de la prestacion a los efectos de la liquidación."
                            buttonApparence={"secondary"}
                            buttonShape="circular"
                            buttonTitle="Presencial"
                            isProcessing={props.isChangingType}
                        />
                        <Button appearance={isRemote ? "primary" : "secondary"} shape="circular">Remoto</Button>
                    </>
                )}
                {isPresential && (
                    <>
                        <Button appearance={isPresential ? "primary" : "secondary"} shape="circular">Presencial</Button>
                        <ConfirmationModalComponent
                            onDismiss={() => handleChange}
                            onConfirm={() => { props.ChangeVisitType(props.ProtocolId, props.Consumption!.id, 1) }}
                            title="Desea cambiar la modalidad de la prestación?"
                            message="Es importante tener en cuenta que al cambiar la modalidad de la prestación, NO se esta modificando la prestacion del servicio en el módulo medico o en la historia clinica. Solo se esta modificando la modalidad de la prestacion a los efectos de la liquidación."
                            buttonApparence={"secondary"}
                            buttonShape="circular"
                            buttonTitle="Remoto"
                            isProcessing={props.isChangingType}
                        />
                    </>
                )}
            </div>
            <Separator />
        </>
    );
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ChangeTypeOfConsumptionComponent as any);